(function () {
  function waitForSwiper(el, callback, attempts) {
    attempts = attempts || 0;
    if (attempts > 20) return; // give up after ~2s
    if (el && el.swiper) {
      callback(el.swiper);
    } else {
      setTimeout(function () {
        waitForSwiper(el, callback, attempts + 1);
      }, 100);
    }
  }

  function initVariantImageSwitch(section) {
    if (!section) return;

    var picker = section.querySelector("variant-radios, variant-selects");
    if (!picker) return;

    var variantsJSON = picker.querySelector('script[type="application/json"]');
    if (!variantsJSON) return;

    var variantsData;
    try {
      variantsData = JSON.parse(variantsJSON.textContent);
    } catch (e) {
      return;
    }

    var mainEl = section.querySelector(".product__media-list.swiper");
    var thumbEl = section.querySelector(".product__media-sublist.swiper");
    var sectionId = picker.dataset.section;

    picker.addEventListener("change", function () {
      // Collect selected options across all fieldsets
      var selectedOptions = [];
      picker.querySelectorAll("fieldset").forEach(function (fieldset) {
        var checked = fieldset.querySelector("input[type='radio']:checked");
        var dropdown = fieldset.querySelector("select");
        if (checked) selectedOptions.push(checked.value);
        else if (dropdown) selectedOptions.push(dropdown.value);
      });

      // Match variant
      var matched = variantsData.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === selectedOptions[i];
        });
      });

      if (!matched || !matched.featured_media) return;

      var targetId = sectionId + "-" + matched.featured_media.id;

      // Find slide index by data-media-id
      var slides = section.querySelectorAll(
        ".product__media-list .swiper-slide[data-media-id]"
      );
      var targetIndex = -1;
      slides.forEach(function (slide, i) {
        if (slide.dataset.mediaId === targetId) targetIndex = i;
      });
      // CTL: SNU-003 the metafield gallery has no variant images, so keep the current slide
      if (targetIndex < 0) return;

      // Navigate main slider
      waitForSwiper(mainEl, function (swiper) {
        swiper.slideTo(targetIndex);
      });

      // Navigate thumbnail slider
      waitForSwiper(thumbEl, function (swiper) {
        swiper.slideTo(targetIndex);
      });
    });
  }

  function init(section) {
    // Small delay to let sliderInit() in update-slider.js run first
    setTimeout(function () {
      initVariantImageSwitch(section);
    }, 300);
  }

  document.addEventListener("shopify:section:load", function (e) {
    init(e.target);
  });

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product-section").forEach(function (section) {
      init(section);
    });
  });
})();